type HideRecommendationColBodyText = {
  btnAriaLabel: string;
  tooltipText: string;
};

export interface HideRecommendationColBodyProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
  text: HideRecommendationColBodyText;
}

export const HideRecommendationColumnBody = ({
  onClick,
  onKeyDown,
  text,
}: HideRecommendationColBodyProps): JSX.Element => {
  return (
    <div
      id="hideBtnWrapper"
      className="columnBtnWrapper"
    >
      <button
        onClick={onClick}
        onKeyDown={onKeyDown}
        className="hideResourceBtn hasTooltip"
        aria-label={text.btnAriaLabel}
        tabIndex={0}
        data-pr-tooltip={text.tooltipText}
        data-pr-position="top"
        data-pr-showdelay={1000}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M12.2 5.2H3.8V12.9C3.8 13.0223 3.86816 13.2033 4.03242 13.3676C4.19668 13.5318 4.37766 13.6 4.5 13.6H11.5C11.6223 13.6 11.8033 13.5318 11.9676 13.3676C12.1318 13.2033 12.2 13.0223 12.2 12.9V5.2ZM5.9 10.8V8C5.9 7.6134 6.2134 7.3 6.6 7.3C6.9866 7.3 7.3 7.6134 7.3 8V10.8C7.3 11.1866 6.9866 11.5 6.6 11.5C6.2134 11.5 5.9 11.1866 5.9 10.8ZM8.7 10.8V8C8.7 7.6134 9.0134 7.3 9.4 7.3C9.7866 7.3 10.1 7.6134 10.1 8V10.8C10.1 11.1866 9.7866 11.5 9.4 11.5C9.0134 11.5 8.7 11.1866 8.7 10.8ZM10.1 3.1C10.1 2.97766 10.0318 2.79668 9.86758 2.63242C9.70332 2.46816 9.52234 2.4 9.4 2.4H6.6C6.47766 2.4 6.29668 2.46816 6.13242 2.63242C5.96816 2.79668 5.9 2.97766 5.9 3.1V3.8H10.1V3.1ZM11.5 3.8H14.3C14.6866 3.8 15 4.1134 15 4.5C15 4.8866 14.6866 5.2 14.3 5.2H13.6V12.9C13.6 13.4777 13.3182 13.9967 12.9574 14.3574C12.5967 14.7182 12.0777 15 11.5 15H4.5C3.92234 15 3.40332 14.7182 3.04258 14.3574C2.68184 13.9967 2.4 13.4777 2.4 12.9V5.2H1.7C1.3134 5.2 1 4.8866 1 4.5C1 4.1134 1.3134 3.8 1.7 3.8H4.5V3.1C4.5 2.52234 4.78184 2.00332 5.14258 1.64258C5.50332 1.28184 6.02234 1 6.6 1H9.4C9.97766 1 10.4967 1.28184 10.8574 1.64258C11.2182 2.00332 11.5 2.52234 11.5 3.1V3.8Z"
            fill="#003C3C"
          />
        </svg>
      </button>
    </div>
  );
};
